/*
 * Action Types
 */
export enum CollapseTypes {
  SET_TOGGLE_COLLAPSE = '@collapse/SET_TOGGLE_COLLAPSE',
}

export interface CollapseInterface {
  id: string;
  title: string;
  open: boolean;
}

/*
 * State type
 */
export interface CollapseState {
  readonly collapseList: CollapseInterface[];
}
